__turbopack_context__.v({
  "arrow": "agpakq_arrow",
  "change": "agpakq_change",
  "compact": "agpakq_compact",
  "details": "agpakq_details",
  "favoriteAction": "agpakq_favoriteAction",
  "favoriteButton": "agpakq_favoriteButton",
  "favoriteShortcut": "agpakq_favoriteShortcut",
  "label": "agpakq_label",
  "message": "agpakq_message",
  "picker": "agpakq_picker",
  "pickerHeading": "agpakq_pickerHeading",
  "remove": "agpakq_remove",
  "shortcut": "agpakq_shortcut",
  "shortcutRow": "agpakq_shortcutRow",
  "teamOptions": "agpakq_teamOptions",
});
